module.exports = __webpack_public_path__ + "static/83-4bf6416fc454ffe1490331b2500541f7.png";